cv.PageGeneralView = Marionette.LayoutView.extend({
  template: cv.Templates["page/general"],

  events: {
    "keyup #stub": "updateStub",
  },

  behaviors: [
    {
      behaviorClass: cv.FormBehavior,
    },
  ],

  validation: {
    display_name: [],
    stub: [
      {
        required: "true",
        msg: "Invalid URL",
      },
      {
        valid_project_stub: true,
      },
    ],
    funds_needed: [
      {
        required: "true",
        msg: " ",
      },
      {
        min: 0,
        msg: "Invalid amount",
      },
    ],
    end_date: [],
    project_updated: [],
    flex_metric_goal: [],
    flex_metric_progress: [],
  },

  templateHelpers: function () {
    return {
      url: cv.campaign.get("url"),
      currency_code: cv.campaign.get("currency_code"),
      enable_project_end_date: cv.campaign.get("enable_project_end_date") == 1 ? true : false,
      enable_flex_metric: cv.campaign.get("enable_flex_metric") == 1 ? true : false,
      flex_metric_description: cv.campaign.get("flex_metric_description"),
      recommended_amount:
        cv.campaign.get("recommended_amount") > 0 ? cv.campaign.get("recommended_amount") : false,
      form_datepicker: cv.Templates["global/form/form_datepicker"]({
        label: "End Date",
        id: "end_date",
        default_date: cv.campaign.get("end_date"),
        timezone: "UTC",
        static: false,
        help_text: "Specify the end date in UTC.",
      }),
    };
  },

  initialize: function (options) {
    this.options = _.extend(this.options, options);

    this.listenTo(
      this,
      "form:saved",
      function () {
        // Refresh the parent UI
        vent.trigger("project:refresh");

        // Rewrite the URL
        history.pushState(null, "", "/" + this.model.get("stub") + "/admin/page/details");

        // Refresh the router
        cv.adminRouter = new cv.AdminRouter(this.model.get("stub") + "/admin");
      },
      this
    );

    console.log("PageGeneralView initialized.");
  },

  updateStub: function () {
    this.$(".url-preview").text(this.$("#stub").val());
  },

  onAttach: function () {},

  onShow: function () {
    this.updateStub();
  },

  onRender: function () {},
});
